import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';

export class TopNavbarCategoryMenuOpenApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.TopNavbarCategoryMenuOpen;

  constructor(private isPromotionsMenu?: boolean) {

  }

  getPayload(): any {
    return {
      isPromotionsMenu: this.isPromotionsMenu
    };
  }
}
